<div class="modal-header bg-white d-block pt-2 pb-2 mb-1  multi-checkbox-header-container">
  <div class="position-relative" *ngIf="!showExistingUsersFlag">
    <div class="position-relative custom-dropdown">
      <span class="icon-left">
        <img src="assets/themes/icons/Search.svg" alt="search" />
      </span>
      <input autocomplete="off" id="conSearch" (keyup)="searchInTheList($event.target.value)" class="input-field"
        [placeholder]="filterPlaceholder" />

      <span class="icon-right">
        <img src="assets/themes/icons/cancel.svg" width="16" height="16" alt="clear search" *ngIf="keyword.length > 0"
          (click)="resetSearchBox()" />
      </span>
    </div>
  </div>
  <div *ngIf="selectedList.length>0 && communityCreatedBy && !showExistingUsersFlag"
    class="d-block d-md-none secondary-paragraph-bold p-2 mt-2">
    <div *ngIf="showForwardArrow" (click)="showExistingUsers()">
      <span>{{mls.languageText.community.key52}} ({{selectedList?.length}})</span>
      <span class="float-right">
        <img src="assets/themes/icons/right-arrow-head.svg" alt="nav icon" class="nav-icon" />
      </span>
    </div>
  </div>
  <small class="text-danger">
    {{maxLimitErrorMsg}}
  </small>
</div>
<div class="modal-body p-0 main-body-heigh multi-checkbox-body-container" *ngIf="!showExistingUsersFlag">

  <!--EOf Loaders-->
  <div class="position-relative">
    <div class="row m-0">
      <div id="containerDiv" class="col-md-7 pr-0 pl-0 multi-select-box-height" [perfectScrollbar]="config"
        infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="1000" (scrolled)="onScroll()"
        [scrollWindow]="false">
        <div *ngIf="suggestionList.length===0 && apiInProcess===true" class='text-center'>
          <img src="assets/themes/images/img-video-loader.gif" width="40" height="40" id="loadmore_post">
        </div>
        <div class="text-center paragraph-bold mt-4" *ngIf="suggestionList.length === 0 && apiInProcess===false">
          <img class="mb-3" src="assets/themes/icons/no-search-result.svg" alt="no-result" /><br />
          {{noDataFoundLabel}}
        </div>
        <ng-container *ngFor="let suggestions of suggestionList">
          <div class="ps position-relative">
            <div class="bg-white px-3 pt-2 pb-2 ml-4 mr-2 mt-3 suggestion-container">
              <p class="mt-2 mb-3 heading-4">
                <img src="assets/themes/icons/back-arrow.svg" alt="back button" *ngIf="isViewAllEnable"
                  (click)="backToSuggestion()" class="mr-2 cursor-pointer" />
                {{suggestions.header}}
              </p>
              <!-- connection list start -->

              <div class="clearfix p-2 cursor-pointer connection-card-container"
                *ngFor="let suggestion of suggestions.list">
                <label class="connection-card cursor-pointer clearfix mb-0 w-100">
                  <div class="connection-items">
                    <div class="row">
                      <div class="col-10 pr-0 d-flex flex-row">
                        <div class="col-2 px-0 box-width-52">
                          <div class="position-relative box-size-40">
                            <app-conn-user-for-tag [conn]="suggestion">
                            </app-conn-user-for-tag>
                          </div>
                        </div>
                        <div class="col-10 px-0 ml-1 width-56">
                          <p class="secondary-paragraph-bold lh-1">
                            <span class="color-grey-700">{{suggestion?.full_name | titlecase}} <span
                                *ngIf="(user?.is_community_creator || user?.community_member_type === memberType?.ADMIN) && (loggedInUserCustomId === suggestion?.custom_id)">({{mls.languageText.community.key51}})</span></span>
                            <span class="ml-2" *ngIf="suggestions.key === memberListType.CONNECTION">
                              <img src="assets/themes/icons/user-connected-icon.svg" alt="user connected icon"
                                height="20" width="20" />
                            </span>
                            <br />
                            <span class="secondary-paragraph" *ngFor="let spec of suggestion.specialities">
                              <span class="color-grey-500">{{(spec.is_primary==1)?
                                spec.speciality_name:''}}</span></span><br />
                            <span class="secondary-paragraph"
                              *ngIf="suggestion?.is_community_creator">{{mls.languageText.community.key50}}</span>
                            <span class="secondary-paragraph"
                              *ngIf="!(suggestion?.is_community_creator) && (suggestion?.community_member_type === memberType?.ADMIN)">{{mls.languageText.community.key53
                              | titlecase}}</span>
                            <span class="secondary-paragraph"
                              *ngIf="!(suggestion?.is_community_creator) && (suggestion?.community_member_type === memberType?.MEMBER)">{{mls.languageText.community.key54
                              | titlecase}}</span>
                          </p>
                        </div>
                      </div>
                      <div class="col-2 text-right" *ngIf="!(suggestion?.is_community_creator)">
                        <label class="checkbox">
                          <input type="checkbox" name=""
                            [checked]="suggestion?.is_community_member === 1  ||checkVal(suggestion)"
                            value="{{suggestion.custom_id}}" (click)="add($event, suggestion)" />
                          <span></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
              <!-- connection list end -->
            </div>
            <div *ngIf="suggestions.list.length >= 6  && suggestions.view_more_text && !isViewAllEnable"
              class="bg-white p-2 text-center  position-relative">
              <button (click)="viewAll(suggestions.key)" class="btn-design small outline mt-2">
                {{suggestions.view_more_text}}
              </button>
              <span *ngIf="apiInProcess==true" class="spinner spinner-border spinner-border-xs position-absolute"
                role="status" aria-hidden="true"></span>
            </div>
          </div>
        </ng-container>
      </div>
      <div [perfectScrollbar]="config" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="1000"
        (scrolled)="onMemberScroll()" [scrollWindow]="false" *ngIf="selectedList.length>0"
        class="d-none d-md-block col-md-5 bg-white pb-3 pt-2 ps position-relative checkbox-modal-max-height">
        <!-- TODO: Nilesh: In 1.46 sprint need to use ngFor for selcted members -->
        <button *ngIf="communityId" class="btn-design small outline  secondary-paragraph-bold mt-2"
          (click)="showExistingMembers()">{{mls.languageText.community.key52}}
          <img width="10px" height="10px" src="assets/themes/icons/right-arrow-head.svg" alt="nav icon" />
        </button>
        <div class="clearfix pt-3 pb-2 last-item-border" *ngFor="let user of selectedList;  let first = first">
          <div *ngIf="first">
            <p class="heading-4 mb-1">
              {{mls.languageText.community.key50 | titlecase}}
            </p>
            <div class="row">
              <div class="col-2 pr-0 box-width-60">
                <div class="position-relative box-size-40">
                  <app-conn-user-for-tag [conn]="user">
                  </app-conn-user-for-tag>
                </div>
              </div>
              <div class="col-8 pl-0 pr-0 width-52">
                <p class="secondary-paragraph-bold lh-1">
                  <span>{{user?.full_name | titlecase}}</span> <span
                    *ngIf="(user?.is_community_creator || user?.community_member_type === memberType?.ADMIN) && (loggedInUserCustomId === user.custom_id)">({{mls.languageText.community.key51}})</span><br />
                  <span class="secondary-paragraph" *ngFor="let spec of user?.specialities">
                    <span clas="color-grey-500">{{ ( spec?.is_primary)? spec?.speciality_name: ''}}</span></span><br />
                  <span class="secondary-paragraph"
                    *ngIf="user?.is_community_creator">{{mls.languageText.community.key50}}</span>
                  <span class="secondary-paragraph"
                    *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.ADMIN)">{{mls.languageText.community.key53
                    | titlecase}}</span>
                  <span class="secondary-paragraph"
                    *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.MEMBER)">{{mls.languageText.community.key54
                    | titlecase}}</span>
                </p>
              </div>
              <div class="col-2 text-right pl-0 pt-1 pr-0"
                *ngIf="!(user?.is_community_creator || (user?.custom_id === loggedInUserCustomId))">
                <span class="cursor-pointer">
                  <svg (click)="unTag(user)" id="Layer_1" width="20px" data-name="Layer 1" viewBox="0 0 24 24">
                    <defs class="cnnt-del cnnt-del2">
                    </defs>
                    <circle class="cnnt-del" cx="12" cy="12" r="11" />
                    <line class="cnnt-del2" x1="8.14" y1="8.17" x2="15.86" y2="15.83" />
                    <line class="cnnt-del2" x1="8.14" y1="15.83" x2="15.86" y2="8.17" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div [perfectScrollbar]="config" *ngIf="selectedList.length>0 && showExistingUsersFlag && communityCreatedBy"
  class="d-block d-md-none col-md-5 pb-3 pt-2 ps position-relative multi-select-box-height">
  <p class="mb-1 heading-4">
    {{selectedTitle}}
  </p>
  <div class="clearfix py-2 border-bottom last-item-border" *ngFor="let user of selectedList">
    <label class="clearfix mb-0 w-100">
      <div class="">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex">
            <div class="pr-2 box-width-60">
              <div class="position-relative box-size-40">
                <app-conn-user-for-tag [conn]="user">
                </app-conn-user-for-tag>
              </div>
            </div>
            <div class=" px-0 box-width-52">
              <p class="lh-1">
                <span class="secondary-paragraph-bold color-grey-700">{{user?.full_name | titlecase}} <span
                    *ngIf="(user?.is_community_creator || user?.community_member_type === memberType?.ADMIN) && (loggedInUserCustomId === user?.custom_id)">({{mls.languageText.community.key51}})</span></span><br />
                <span class="secondary-paragraph" *ngFor="let spec of user?.specialities">
                  <span class="color-grey-500">{{ ( spec?.is_primary)? spec?.speciality_name: ''}}</span></span><br />
                <span class="secondary-paragraph"
                  *ngIf="user?.is_community_creator">{{mls.languageText.community.key50}}</span>
                <span class="secondary-paragraph"
                  *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.ADMIN)">{{mls.languageText.community.key53
                  | titlecase}}</span>
                <span class="secondary-paragraph"
                  *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.MEMBER)">{{mls.languageText.community.key54
                  | titlecase}}</span>
              </p>
            </div>
          </div>
          <div class="text-right px-0 pt-1"
            *ngIf="!(user?.is_community_creator || (user?.custom_id == loggedInUserCustomId))">
            <span class="checkbox cursor-pointer">
              <input type="checkbox" name="" [checked]="checkVal(user)" value="{{user?.custom_id}}"
                (click)="unTag(user)">
              <span></span>
            </span>
          </div>
        </div>
      </div>
    </label>
  </div>
</div>

<!-- Show existing members -->
<div *ngIf="showMemberModal" id="likeBoxModal" class="modal fade" tabindex="-1" role="dialog" [config]="{ show: true }"
  (onHidden)="closeExistingMember()" bsModal #autoShownModal="bs-modal">
  <div class="custom-theme-modal modal-dialog modal-dialog-scrollable " role="document">
    <div class="modal-content">
      <div class="modal-header pt-2">
        <span class="close" data-dismiss="modal" aria-label="Close" (click)="closeExistingMember()">
          <span aria-hidden="true">
            <img src="assets/themes/icons/cancel.svg" alt="close icon" class="cursor-pointer" />
          </span>
        </span>
      </div>
      <div class="modal-body pt-0 pb-2 pl-2 ml-3" infiniteScroll [infiniteScrollDistance]="5"
        [infiniteScrollThrottle]="1000" [scrollWindow]="false" (scrolled)="onExistingMembersScroll();">
        <p class="heading-4 mb-3">{{mls.languageText.community.key150}}</p>
        <ul class="clearfix">
          <li class="pt-2 pb-2 member-card" *ngFor="let user of memberList">
            <div class="row">
              <div class="col-2 pr-0 width-60 mr-l">
                <div class="position-relative box-size-40">
                  <app-conn-user-for-tag [conn]="user">
                  </app-conn-user-for-tag>
                </div>
              </div>
              <div class="col-8 px-0 box-width-52">
                <p class="lh-1 pl-4">
                  <span class="secondary-paragraph-bold">{{user?.full_name | titlecase}}
                    <span
                      *ngIf="(user?.is_community_creator || user?.community_member_type === memberType?.ADMIN) && (loggedInUserCustomId === user?.custom_id)">({{mls.languageText.community.key51}})</span></span>
                  <br />
                  <span class="secondary-paragraph" *ngFor="let spec of user?.specialities">
                    <span class="color-grey-500">{{ ( spec?.is_primary)? spec?.speciality_name: ''}}</span>
                  </span>
                  <br />
                  <span class="secondary-paragraph"
                    *ngIf="user?.is_community_creator">{{mls.languageText.community.key50}}</span>
                  <span class="secondary-paragraph"
                    *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.ADMIN)">{{mls.languageText.community.key53
                    | titlecase}}</span>
                  <span class="secondary-paragraph"
                    *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.MEMBER)">{{mls.languageText.community.key54
                    | titlecase}}</span>
                </p>
              </div>
            </div>
          </li>
          <img *ngIf="existingmembersLoader==true" src="assets/themes/images/img-video-loader.gif" width="40"
            height="40" id="loadmore_post" alt="loader" />
        </ul>
      </div>
    </div>
  </div>
</div>